module.exports = __webpack_public_path__ + "img/about5.e5354bb8.png";